import { Route, Routes } from "react-router-dom"
import History from "../../pages/History"
import SbpOutcomeTransferStatus from "../../pages/SbpOutcomeTransfer/Status"
import { ROUTES_PATHS } from "../../utils/constants"

const HistoryFlow = () => (
  <Routes>
    <Route element={<History />} index />
    <Route
      path={`:${ROUTES_PATHS.transactionId}`}
      element={<SbpOutcomeTransferStatus outcomeTransferId="" />}
    />
  </Routes>
)

export default HistoryFlow
